import { h } from 'vue';
import { a as registerComponent } from './plugins-C7548x21.js';

const BSkeleton = (props) => {
    if (!props.active) return
    const items = [];
    const width = props.width;
    const height = props.height;
    for (let i = 0; i < props.count; i++) {
        items.push(h('div', {
            class: [
                'b-skeleton-item',
                { 'is-rounded': props.rounded }
            ],
            key: i,
            style: {
                height: height === undefined
                    ? null
                    : (isNaN(height) ? height : height + 'px'),
                width: width === undefined
                    ? null
                    : (isNaN(width) ? width : width + 'px'),
                borderRadius: props.circle ? '50%' : null
            }
        }));
    }
    return h(
        'div',
        {
            class: [
                'b-skeleton',
                props.size,
                props.position,
                { 'is-animated': props.animated }
            ]
        },
        items
    )
};

BSkeleton.props = {
    active: {
        type: Boolean,
        default: true
    },
    animated: {
        type: Boolean,
        default: true
    },
    width: [Number, String],
    height: [Number, String],
    circle: Boolean,
    rounded: {
        type: Boolean,
        default: true
    },
    count: {
        type: Number,
        default: 1
    },
    position: {
        type: String,
        default: '',
        validator(value) {
            return [
                '',
                'is-centered',
                'is-right'
            ].indexOf(value) > -1
        }
    },
    size: String
};

var script = BSkeleton;

script.__file = "src/components/skeleton/Skeleton.vue";

var Plugin = {
  install: function install(Vue) {
    // explicit `name` is needed to avoid name mangling of
    // Functional Component in production
    registerComponent(Vue, script, 'BSkeleton');
  }
};

export { script as BSkeleton, Plugin as default };
